import { simplePath } from "../utils.js";
const GET_ORG_TEAM_LIST_PATH = "/v2/organization/:organization/team-list";
function get_org_team_list_path(params) {
    return simplePath(GET_ORG_TEAM_LIST_PATH, params);
}
export { GET_ORG_TEAM_LIST_PATH, get_org_team_list_path };
